export enum LoadStates {
    SELECT_PAYMENT,
    SUCCESS,
    DPAY_ERROR,
}